import { render, staticRenderFns } from "./EditPlatformExportfileSendConfigComponent.vue?vue&type=template&id=76607517&"
import script from "./EditPlatformExportfileSendConfigComponent.vue?vue&type=script&lang=js&"
export * from "./EditPlatformExportfileSendConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports